import { EnrollmentStatus } from '@zorro/clients';
import type { EmployeesReportRowDto } from '@zorro/clients';

import type { Filter } from '../Filters/FilterUtils';

export const getInitialEmployeesTableFilters = (
  initialEnrollmentStatus: string | null
): Filter<EmployeesReportRowDto>[] => {
  const enrollmentStatus = Object.values(EnrollmentStatus).find(
    (status) => status === initialEnrollmentStatus
  );

  if (!enrollmentStatus) {
    return [];
  }

  return [
    {
      type: 'enrollmentStatus',
      value: [enrollmentStatus],
      filterCallback: (record) => record.enrollmentStatus === enrollmentStatus,
    },
  ];
};
